module.exports = __webpack_public_path__ + "static/media/Gogoat_gaussian2.0c422171.png";